import React from 'react';
import { AtomicBlockUtils, EditorState, SelectionState, Modifier } from 'draft-js';

function UploadPlaceholder(props) {
  var blockProps = props.blockProps,
      block = props.block;
  return /*#__PURE__*/React.createElement("span", {
    contentEditable: false,
    "data-offset-key": block.get('key') + "-0-0"
  }, "![Uploading ", blockProps.resizeData.name, "...](", blockProps.resizeData.progress, ")", ' ');
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);

  if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }

  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var insertPlaceholder = function insertPlaceholder(editorState, text) {
  var contentState = editorState.getCurrentContent();
  var contentStateWithEntity = contentState.createEntity('UploadPlaceholder', 'IMMUTABLE', {
    name: text,
    progress: '0%'
  });
  var entityKey = contentStateWithEntity.getLastCreatedEntityKey();
  var newEditorState = AtomicBlockUtils.insertAtomicBlock(editorState, entityKey, ' ');
  var stateSelected = EditorState.forceSelection(newEditorState, newEditorState.getCurrentContent().getSelectionAfter());
  var blockArrayMap = newEditorState.getCurrentContent().getBlocksAsArray().map(function (b) {
    return b.getKey();
  });
  var nextToLastBlock = newEditorState.getCurrentContent().getBlockForKey(blockArrayMap[blockArrayMap.length - 2]);
  return {
    state: stateSelected,
    blockKey: nextToLastBlock.getKey(),
    key: entityKey,
    text: text
  };
};

function modifyBlockData(editorState, key, data) {
  var currentContentState = editorState.getCurrentContent(); //const block = currentContentState.getBlockForKey(key);
  //const entityKey = block.getEntityAt(0)

  currentContentState.mergeEntityData(key, data);
  return EditorState.forceSelection(editorState, editorState.getCurrentContent().getSelectionAfter());
}

function removeBlock(editorState, blockKey) {
  var content = editorState.getCurrentContent();
  var block = content.getBlockForKey(blockKey);
  var targetRange = new SelectionState({
    anchorKey: blockKey,
    anchorOffset: 0,
    focusKey: blockKey,
    focusOffset: block.getLength()
  });
  var withoutBlock = Modifier.removeRange(content, targetRange, "backward");
  var resetBlock = Modifier.setBlockType(withoutBlock, withoutBlock.getSelectionAfter(), "unstyled");
  var newState = EditorState.push(editorState, resetBlock, "remove-range");
  var newStateWithoutBlock = EditorState.forceSelection(newState, resetBlock.getSelectionAfter());
  return newStateWithoutBlock;
}

// Read file contents intelligently as plain text/json, image as dataUrl or
// anything else as binary
function readFile(file) {
  return new Promise(function (resolve) {
    var reader = new FileReader(); // This is called when finished reading

    reader.onload = function (event) {
      // Return an array with one image
      resolve({
        // These are attributes like size, name, type, ...
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        lastModifiedDate: file.lastModifiedDate,
        lastModified: file.lastModified,
        name: file.name,
        size: file.size,
        type: file.type,
        // This is the files content as base64
        src: event.target.result
      });
    };

    if (file.type.indexOf('text/') === 0 || file.type === 'application/json') {
      reader.readAsText(file);
    } else if (file.type.indexOf('image/') === 0) {
      reader.readAsDataURL(file);
    } else {
      reader.readAsBinaryString(file);
    }
  });
} // Read multiple files using above function

function readFiles(files) {
  return Promise.all(files.map(readFile));
}

var placeholderBlocksList = [];
function onDropFile(config) {
  return function onDropFileInner(selection, files, _ref) {
    var getEditorState = _ref.getEditorState,
        setEditorState = _ref.setEditorState;
    // Get upload function from config.
    var handleUpload = config.handleUpload;

    if (handleUpload) {
      var formData = new FormData();
      var data = {
        files: [],
        formData: formData
      };

      for (var _iterator = _createForOfIteratorHelperLoose(files), _step; !(_step = _iterator()).done;) {
        var file = _step.value;

        // eslint-disable-line no-restricted-syntax
        if (file && file instanceof File) {
          data.formData.append('files', file);
          data.files.push(file);
        }
      }

      setEditorState(EditorState.acceptSelection(getEditorState(), selection)); // Read files on client side

      readFiles(data.files).then(function (placeholders) {
        // Add upload placeholders for each image before uploading
        var _editorState = getEditorState();

        placeholderBlocksList = [];
        placeholders.forEach(function (placeholder) {
          var customBlockProps = insertPlaceholder(_editorState, placeholder.name);
          var state = customBlockProps.state,
              key = customBlockProps.key,
              text = customBlockProps.text,
              blockKey = customBlockProps.blockKey;
          placeholderBlocksList.push({
            key: key,
            text: text,
            blockKey: blockKey
          });
          _editorState = state;
        });
        setEditorState(_editorState);
        handleUpload(data, // TODO: what does retainSrc do? Is it useful to keep this option.
        function (uploadedFiles) {
          /* Success! */

          /*
           * TODO:
           * This removes all placeholders and inserts all uploaded images,
           * Since fail() function removes placeholders for the files that have been marked as failing by the fail()
           * function, those placeholders can be safely removed here, but perhaps it would be useful
           * to modify `placeholderBlocksList` at some point on the fail() function.
           */
          var editorState = getEditorState();
          placeholderBlocksList.forEach(function (element) {
            editorState = removeBlock(editorState, element.blockKey);
          });
          setEditorState(editorState);

          if (uploadedFiles) {
            uploadedFiles.forEach(function (file) {
              if (config.addImage) {
                editorState = config.addImage(editorState, file.src);
              }
            });
            setEditorState(editorState);
          }
        }, function (file) {
          /* On fail */
          // Failed to upload a given file.
          // Remove placeholder for the file.
          // Any other special handling of this use case should be done manually by the user.
          var editorState = getEditorState();
          var blockInList = placeholderBlocksList.find(function (p) {
            return p.text === file.name;
          });

          if (blockInList !== undefined) {
            editorState = removeBlock(editorState, blockInList.blockKey);
            setEditorState(editorState);
          }
        }, function (percent, file) {
          /* On progress */
          var newEditorState = getEditorState();
          var block = placeholderBlocksList.find(function (p) {
            return p.text === file.name;
          });

          if (block !== undefined) {
            var blockData = {
              name: file.name,
              progress: percent + "%"
            };
            newEditorState = modifyBlockData(newEditorState, block.key, blockData);
            setEditorState(newEditorState);
          }
        });
      });
      return 'handled';
    }

    return 'not-handled';
  };
}

var createDndFileUploadPlugin = function createDndFileUploadPlugin(config) {
  if (config === void 0) {
    config = {};
  }

  return {
    // Handle file drops
    handleDroppedFiles: onDropFile(config),
    blockRendererFn: function blockRendererFn(block, _ref) {
      var getEditorState = _ref.getEditorState;

      if (block.getType() === 'atomic') {
        var contentState = getEditorState().getCurrentContent();
        var entity = block.getEntityAt(0);
        if (!entity) return null;
        var type = contentState.getEntity(entity).getType();

        if (type === 'UploadPlaceholder' || type === 'PLACEHOLDER') {
          return {
            component: UploadPlaceholder,
            editable: false
          };
        }

        return null;
      }

      return null;
    }
  };
};

export { createDndFileUploadPlugin as default, readFile, readFiles };
